export default __webpack_public_path__ + "static/media/bell 1.972bd8f2.svg";